// Global loaded data storage
export const LoadedProducts = {};
export const LoadedExtraProducts = {};
// Global flags
let _isOptionSorted = false;
export const isOptionSorted = _isOptionSorted;
export const setIsOptionSorted = (value) => {
    _isOptionSorted = value;
};
// Product type detection helpers
export const isProductPool = (product) => {
    return !!(product.metafields['SB-P']['Length'] && product.metafields['SB-P']['Width'] && product.tags.some((tag) => tag.includes('Poolsten:Rak')));
};
export const isProductBags = (product) => {
    return !!(product.metafields['SB-P']['BagSize'] && product.metafields['SB-P']['BagDensity']);
};
export const isProductStair = (product) => {
    return !!(product.metafields['SB-P']['Length'] &&
        product.metafields['SB-P']['Width'] &&
        product.tags.some((tag) => tag.includes('stair-calculator')));
};
export const isProductSample = (product) => {
    return product.tags.includes('sample');
};
// Filter functions
export const filterHorn = (productData) => {
    return productData.tags.some((tag) => tag.includes('Poolsten:Hörn'));
};
// Array utility
export const ArrayContains = (array, value) => {
    return array.some((item) => item.includes(value));
};
